<p-table
	#tableHistorique
	[value]="values"
	[lazy]="true"
	(onLazyLoad)="loadHistorique($event)"
	[loading]="loading"
	[paginator]="true"
	[rows]="rows"
	[showCurrentPageReport]="true"
	[totalRecords]="totalRecords"
	currentPageReportTemplate="{{totalRecords | number}} {{'common.table_total_records'|translate}}"
	[rowsPerPageOptions]="[10,25,50]"
	styleClass="p-datatable-sm p-datatable-gridlines table-scrollable-hover"
	[autoLayout]="true"
	responsiveLayout="scroll"
	scrollDirection="both"
	[scrollable]="true"
	scrollHeight="flex"
>
	<!-- Header -->
	<ng-template pTemplate="header">
		<tr>
			<th class="text-center">
				{{ 'common.modification_date_label' | translate }}
			</th>

			<th class="text-center">
				{{ 'common.modifier_label' | translate }}
			</th>
		</tr>
	</ng-template>

	<ng-template pTemplate="body" let-hist>
		<tr>
			<td>{{hist.hno_date | date:'short'}}</td>

			<td>{{hist | utilisateur:true}}</td>
		</tr>
	</ng-template>

</p-table>
